module.exports = __webpack_public_path__ + "static/media/SouthWesternTimes-devicecomp-min@2x.54f78c3b.png";